import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { OPCModule } from '../opc/opc-app/opc.module';
import { ExportComponent } from '../opc/opc-admin/export/export.component';
import { AuthorizationService } from './authorization.service';
import { FetchRequestor, Requestor } from '@openid/appauth';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent,
    ExportComponent,
  ],
  imports: [
    BrowserModule,
    OPCModule,
    BrowserAnimationsModule
  ],
  providers: [AuthorizationService,
    { provide: Requestor, useValue: new FetchRequestor() },
    { provide: 'AuthorizationConfig', useValue: environment }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts